import { Component, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppStateService } from '../../services/app-state.service';
import { CmsApiResponse, CmsPageService } from '../../services/cms-page.service';
import { LegalCmsContent } from '../../models/types';
import {
  LEGAL_CMS_MAP,
  parseLegalCmsContent,
} from '../../config/legal-cms.defaults';

@Component({
  selector: 'app-legal-page',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './legal-page.component.html',
})
export class LegalPageComponent implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute);
  private cmsPageService = inject(CmsPageService);
  state = inject(AppStateService);
  private routeSub?: Subscription;

  loading = signal(true);
  content = signal<LegalCmsContent | null>(null);

  ngOnInit() {
    this.routeSub = this.route.data.subscribe((data) => {
      const identifier = data['cmsIdentifier'] as string;
      const fallback = LEGAL_CMS_MAP[identifier];
      this.applyCmsResponse(data['cmsResponse'] as CmsApiResponse | null, fallback);
    });
  }

  ngOnDestroy() {
    this.routeSub?.unsubscribe();
  }

  private applyCmsResponse(res: CmsApiResponse | null, fallback: LegalCmsContent) {
    this.loading.set(true);

    const cms =
      res?.status && res.data?.content
        ? parseLegalCmsContent(res.data.content, fallback)
        : fallback;

    this.content.set(cms);
    this.cmsPageService.applyPageSeo(cms.seo);
    this.loading.set(false);
  }
}
